"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-regular-svg-icons";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import CommonCalendar from "@/components/utils/calendar/CommonCalendar";
import { CreateWaveDatesConfig } from "@/types/waves.types";
import { CREATE_WAVE_START_DATE_LABELS } from "@/helpers/waves/waves.constants";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import { Time } from "@/helpers/time";
import DateAccordion from "@/components/common/DateAccordion";
import TooltipIconButton from "@/components/common/TooltipIconButton";
interface StartDatesProps {
  readonly waveType: ApiWaveType;
  readonly dates: CreateWaveDatesConfig;
  readonly setDates: (dates: CreateWaveDatesConfig) => void;
  readonly isExpanded: boolean;
  readonly setIsExpanded: (expanded: boolean) => void;
}
export default function StartDates(t0) {
  const $ = _c(53);
  const {
    waveType,
    dates,
    setDates,
    isExpanded,
    setIsExpanded
  } = t0;
  const [minVotingTimestamp, setMinVotingTimestamp] = useState(null);
  const isRankWave = waveType === ApiWaveType.Rank;
  let t1;
  let t2;
  if ($[0] !== dates.submissionStartDate || $[1] !== isRankWave) {
    t1 = () => {
      setMinVotingTimestamp(isRankWave ? dates.submissionStartDate : null);
    };
    t2 = [isRankWave, dates.submissionStartDate];
    $[0] = dates.submissionStartDate;
    $[1] = isRankWave;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== dates || $[5] !== isRankWave || $[6] !== setDates) {
    t3 = timestamp => {
      const adjustedTimestamp = Math.max(timestamp, Time.currentMillis());
      setDates({
        ...dates,
        submissionStartDate: adjustedTimestamp,
        votingStartDate: isRankWave ? Math.max(dates.votingStartDate, adjustedTimestamp) : adjustedTimestamp
      });
    };
    $[4] = dates;
    $[5] = isRankWave;
    $[6] = setDates;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleSubmissionDateChange = t3;
  let t4;
  if ($[8] !== dates || $[9] !== setDates) {
    t4 = timestamp_0 => {
      setDates({
        ...dates,
        votingStartDate: Math.max(timestamp_0, dates.submissionStartDate)
      });
    };
    $[8] = dates;
    $[9] = setDates;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleVotingDateChange = t4;
  const formatShortDate = _temp;
  let t5;
  if ($[11] !== dates.submissionStartDate) {
    t5 = formatShortDate(dates.submissionStartDate);
    $[11] = dates.submissionStartDate;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const submissionDateFormatted = t5;
  let t6;
  if ($[13] !== dates.votingStartDate) {
    t6 = formatShortDate(dates.votingStartDate);
    $[13] = dates.votingStartDate;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const votingDateFormatted = t6;
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-2"><span>Wave Timeline</span><TooltipIconButton icon={faInfoCircle} tooltipText="Set when your wave begins accepting submissions and when voting starts. These dates create the foundational timeline for your wave." tooltipPosition="bottom" tooltipWidth="tw-w-80" /></div>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isExpanded || $[17] !== setIsExpanded) {
    t8 = () => setIsExpanded(!isExpanded);
    $[16] = isExpanded;
    $[17] = setIsExpanded;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t10;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FontAwesomeIcon icon={faCalendarDays} className="tw-mr-2 tw-size-4 tw-text-primary-400" />;
    t10 = <p className="tw-mb-0 tw-text-xs tw-text-iron-300/70">Drops Submission Opens</p>;
    $[19] = t10;
    $[20] = t9;
  } else {
    t10 = $[19];
    t9 = $[20];
  }
  let t11;
  if ($[21] !== submissionDateFormatted) {
    t11 = <div className="tw-flex tw-items-center tw-bg-iron-700/40 tw-px-3 tw-py-2 tw-rounded-lg tw-shadow-md hover:tw-translate-y-[-1px] tw-transition-transform tw-duration-200">{t9}<div>{t10}<p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-50">{submissionDateFormatted}</p></div></div>;
    $[21] = submissionDateFormatted;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isRankWave || $[24] !== votingDateFormatted) {
    t12 = isRankWave && <div className="tw-flex tw-items-center tw-bg-iron-700/40 tw-px-3 tw-py-2 tw-rounded-lg tw-shadow-md hover:tw-translate-y-[-1px] tw-transition-transform tw-duration-200"><FontAwesomeIcon icon={faCalendarDays} className="tw-mr-2 tw-size-4 tw-text-primary-400" /><div><p className="tw-mb-0 tw-text-xs tw-text-iron-300/70">Drops Voting Begins</p><p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-50">{votingDateFormatted}</p></div></div>;
    $[23] = isRankWave;
    $[24] = votingDateFormatted;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div className="tw-flex tw-items-center tw-space-x-4">{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  const t14 = CREATE_WAVE_START_DATE_LABELS[waveType];
  let t15;
  if ($[29] !== t14) {
    t15 = <p className="tw-mb-0 tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50">{t14}</p>;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="tw-text-xs tw-text-iron-400 tw-mt-1">Creators begin submitting work to your wave</p>;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  let t18;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = new Date().getMonth();
    t18 = new Date().getFullYear();
    $[32] = t17;
    $[33] = t18;
  } else {
    t17 = $[32];
    t18 = $[33];
  }
  let t19;
  if ($[34] !== dates.submissionStartDate || $[35] !== handleSubmissionDateChange) {
    t19 = <div className="tw-mt-4"><CommonCalendar initialMonth={t17} initialYear={t18} selectedTimestamp={dates.submissionStartDate} minTimestamp={null} maxTimestamp={null} setSelectedTimestamp={handleSubmissionDateChange} /></div>;
    $[34] = dates.submissionStartDate;
    $[35] = handleSubmissionDateChange;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== t15 || $[38] !== t19) {
    t20 = <div className="tw-col-span-1">{t15}{t16}{t19}</div>;
    $[37] = t15;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== dates.votingStartDate || $[41] !== handleVotingDateChange || $[42] !== isRankWave || $[43] !== minVotingTimestamp) {
    t21 = isRankWave && <div className="tw-col-span-1"><p className="tw-mb-0 tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50">Drops Voting Begins</p><p className="tw-text-xs tw-text-iron-400 tw-mt-1">Community voting on wave submissions begins</p><div className="tw-mt-4"><CommonCalendar initialMonth={new Date().getMonth()} initialYear={new Date().getFullYear()} selectedTimestamp={dates.votingStartDate} minTimestamp={minVotingTimestamp} maxTimestamp={null} setSelectedTimestamp={handleVotingDateChange} /></div></div>;
    $[40] = dates.votingStartDate;
    $[41] = handleVotingDateChange;
    $[42] = isRankWave;
    $[43] = minVotingTimestamp;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t20 || $[46] !== t21) {
    t22 = <div className="tw-grid tw-grid-cols-1 tw-gap-y-8 tw-gap-x-10 md:tw-grid-cols-2 tw-px-5 tw-pb-5 tw-pt-2">{t20}{t21}</div>;
    $[45] = t20;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== isExpanded || $[49] !== t13 || $[50] !== t22 || $[51] !== t8) {
    t23 = <DateAccordion title={t7} isExpanded={isExpanded} onToggle={t8} collapsedContent={t13}>{t22}</DateAccordion>;
    $[48] = isExpanded;
    $[49] = t13;
    $[50] = t22;
    $[51] = t8;
    $[52] = t23;
  } else {
    t23 = $[52];
  }
  return t23;
}
function _temp(timestamp_1) {
  return new Date(timestamp_1).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });
}